import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import { MTCampaignTypeEnum, campaignTypeEnum } from './campaignType';

export const isBidLessThanFiveCentsForShoppingCampaign = (currentCampaignType = null, isBulkEdit = false) => {
  const IsBidLessThan5CentsInShoppingCampaignEnabled = _.result(config.get('permissions'), 'IsBidLessThan5CentsInShoppingCampaignEnabled');

  // currentCampaignType is passed from shopping campaign creation where CurrentCampaign is null
  const campaignType = currentCampaignType || _.result(config.get('CurrentCampaign'), 'CampaignType');

  return IsBidLessThan5CentsInShoppingCampaignEnabled &&
    (campaignType === MTCampaignTypeEnum.Shopping || campaignType === campaignTypeEnum[MTCampaignTypeEnum.Shopping] || isBulkEdit);
};
